/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/xoxa/"

// Mapped from Figma "WERZ - Community - XOXO (Copy)" (RPsY9E86DzjRbzv00s2R2H) -> Community / Web
// (576:18822): Landing desktop (235:2068) / mobile (363:9081), Event (987:17150, 367:2839),
// Event / Tickets (235:8023), Shop (1158:14862). Same template as HIGHTS: #17111d aside and content
// card split by white dividers, crimson #c82550 buttons with an 8px radius and a 2px border.
const XOXA: CommunityData = {
  code: "xoxa",
  inviteCode: "xoxa",
  name: "XOXA",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/xox-917`,
  waitlist: false,
  socials: {},
  styles: {
    global: {
      counterColor: "#ffffff",
      werzLogoColor: "#ffffff",
      // Square icon (wordmark on black) for the surfaces that read logo.src: the join gate's 96px
      // circle, the claim card and the download page
      logo: {
        src: `${S3_PREFIX}community-icon.jpg`,
        styles: "w-[96px] h-[96px] object-contain",
      },
      // Wordmark for the aside (Figma 190 wide) and the mobile menu bar (94 wide)
      alternativeLogo: {
        src: `${S3_PREFIX}web-logo.png`,
        styles: "w-[94px] h-[34px] sm:w-[190px] sm:h-[69px] object-contain",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#17111d",
      asideBg: "#17111d",
      asideStyles: "!p-0 !gap-0 border-r border-[#ffffff]",
      contentBg: "#17111d",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.jpg`,
      bgMobile: `${S3_PREFIX}web-background-mobile.jpg`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.jpg`,
      // Full-height background behind the join gate (Figma 235:9051 is full-bleed)
      nonMemberBgContainerStyles: "sm:!h-screen",
      mainFont: "font-['ArimoRegular']",
      primaryButton:
        "bg-[#c82550] border-2 border-[#c82550] rounded-[8px] !px-[18px] !h-[46px] sm:!h-[46px] !text-[#ffffff] font-['BaseNeueCondensedBold'] !text-[16px] tracking-[0.04em] uppercase text-left leading-[100%]",
      scrollArrow: {
        background: "#c82550",
        color: "#ffffff",
      },
    },
    navigation: {
      iconsColor: "#ffffff",
      sideBarSeparator: "border-r-[1px] border-[#ffffff]",
      separator: "border-[#ffffff]",
      item: "font-['BaseNeueCondensedBold'] text-[16px] tracking-[0.04em] text-[#ffffff] uppercase leading-[100%] gap-x-[10px] text-opacity-50 text-center border-b border-[#ffffff] !pl-0 !py-4",
      itemSelected: " !text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#17111d] overflow-hidden !pt-0 !pb-4 sm:!pb-8 !mb-0",
      titles:
        "text-[#ffffff] font-['BaseNeueCondensedBold'] text-[32px] tracking-[0.04em] text-left leading-[120%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#ffffff] font-['ArimoRegular'] text-[14px] text-left leading-[120%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#ffffff]",
        sectionTitle:
          "text-[#ffffff] font-['BaseNeueCondensedBold'] text-[32px] tracking-[0.04em] text-left leading-[120%] pl-4 sm:pl-8 !mb-4 sm:!mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-6",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden !bg-[#ffffff00]",
          mediaContainer: "w-full sm:w-[256px] relative overflow-hidden",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col px-0 pt-4 bg-transparent",
          title:
            "text-[#ffffff] font-['BaseNeueCondensedMedium'] text-[22px] uppercase tracking-[0.04em] text-left leading-[120%]",
          subtitle:
            "text-[#ffffff] font-['ArimoRegular'] text-[14px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#ffffff]",
        sectionTitle:
          "text-[#ffffff] font-['BaseNeueCondensedBold'] text-[32px] tracking-[0.04em] text-left leading-[120%] pl-4 sm:pl-8 !mb-4 sm:!mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[420px] h-full overflow-hidden !bg-[#ffffff00]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative overflow-hidden",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full !aspect-video bg-gray-400",
          content: "flex flex-col px-0 sm:pl-3 sm:pr-0 pt-4 sm:!pt-0 bg-transparent",
          title:
            "text-[#ffffff] font-['BaseNeueCondensedMedium'] text-[22px] uppercase sm:normal-case sm:text-[16px] tracking-[0.04em] text-left leading-[120%]",
          subtitle:
            "text-[#ffffff] font-['ArimoRegular'] text-[14px] sm:text-[12px] text-left leading-[120%] mt-2",
          location:
            "text-[#ffffff] font-['ArimoRegular'] text-[14px] sm:text-[12px] text-left leading-[120%] mt-1",
          date: "text-[#ffffff] font-['ArimoRegular'] text-[14px] sm:text-[12px] text-left leading-[120%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !m-0 space-y-0 !border-0 overflow-hidden",
        title:
          "text-[#ffffff] font-['BaseNeueCondensedMedium'] text-[28px] tracking-[0.04em] text-left leading-[120%]",
        text: "text-[#ffffff] font-['ArimoRegular'] text-[16px] text-left leading-[120%]",
        // Component hardcodes 456x288; Figma is 420x236 desktop, full-width 16:9 mobile.
        customShopImageStyle: "!h-auto !aspect-video sm:!w-[420px]",
        sectionTitle:
          "text-[#ffffff] font-['BaseNeueCondensedBold'] text-[32px] tracking-[0.04em] text-left leading-[120%] !mb-4 sm:!mb-6",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#17111d] overflow-hidden !pb-4 sm:!pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-8 sm:p-8 p-4 border-b border-[#ffffff]",
        media: "!w-full sm:!w-[320px] !h-auto !aspect-video object-cover sm:mb-4 !border-0",
        title:
          "text-[#ffffff] font-['BaseNeueCondensedMedium'] text-[28px] sm:font-['BaseNeueCondensedBold'] sm:text-[32px] tracking-[0.04em] text-left leading-[120%]",
        subtitle:
          "text-[#ffffff] font-['ArimoRegular'] text-[14px] text-left leading-[120%] mb-4 mt-2",
        button: "!w-fit mb-4 sm:mb-0",
        // Figma: crimson, regular-weight, underlined contact link (the page sets it bold)
        questions:
          "font-['ArimoRegular'] text-[14px] leading-[120%] text-left !text-[#ffffff] [&_a]:!text-[#c82550] [&_a]:underline [&_a]:!font-normal",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#ffffff]",
        header:
          "text-[#ffffff] font-['BaseNeueCondensedMedium'] text-[28px] tracking-[0.04em] text-left leading-[120%]",
        text: "text-[#ffffff] font-['ArimoRegular'] text-[14px] text-left leading-[120%] w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#ffffff]",
        header:
          "text-[#ffffff] font-['BaseNeueCondensedMedium'] text-[28px] tracking-[0.04em] text-left leading-[120%]",
        text: "text-[#ffffff] font-['ArimoRegular'] text-[14px] text-left leading-[120%] max-w-[652px] w-full",
        // Wrappers hardcode 307x204 / 309x206; Figma is 350x196 desktop, full-width 16:9 mobile.
        map: "!w-full sm:!w-[350px] !h-auto !aspect-video overflow-hidden",
        mapPinColor: "#ffffff",
        mapStrokeColor: "#ffffff00",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:gap-6 sm:p-8 p-4",
        header:
          "text-[#ffffff] font-['BaseNeueCondensedMedium'] text-[28px] tracking-[0.04em] text-left leading-[120%]",
        text: "text-[#ffffff] font-['ArimoRegular'] text-[16px] text-left leading-[120%]",
      },
      tickets: {
        // First ticket's py-4 adds 16px, so mb-2 lands on Figma's 24px header gap on desktop.
        header:
          "text-[#ffffff] font-['BaseNeueCondensedMedium'] text-[28px] tracking-[0.04em] text-left leading-[120%] px-4 sm:px-8 pt-4 sm:pt-8 mb-0 sm:mb-2 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#17111d] !pb-4 sm:!pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#c82550] border-2 border-[#c82550] rounded-[8px] flex items-center justify-center px-[12px] text-[#ffffff] font-['BaseNeueCondensedBold'] text-[14px] tracking-[0.04em] uppercase leading-[100%] !w-fit !h-[33px]",
        },
        ticket: {
          container:
            "flex flex-row justify-between gap-x-4 leading-auto !bg-[#ffffff00] border-b border-[#ffffff] overflow-hidden py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#ffffff] font-['BaseNeueCondensedMedium'] text-[16px] tracking-[0.04em] text-left leading-[120%] mb-1",
          description:
            "text-[#ffffff] font-['ArimoRegular'] text-[14px] text-left leading-[120%] mb-1",
          price:
            "text-[#ffffff] font-['BaseNeueCondensedMedium'] text-[16px] tracking-[0.04em] text-left leading-[120%]",
          quantity:
            "text-[#ffffff] font-['BaseNeueCondensedBold'] text-[14px] tracking-[0.04em] uppercase text-left leading-[100%]",
          status:
            "text-[#ffffff] font-['BaseNeueCondensedMedium'] text-[16px] tracking-[0.04em] text-left leading-[120%]",
          counterContainer:
            "bg-[#c82550] !border-2 border-[#c82550] rounded-[8px] px-[12px] py-[12px] gap-x-[16px] !w-fit !h-9",
          plusMinusColor: "#ffffff",
          button:
            "bg-[#c82550] border-2 border-[#c82550] rounded-[8px] flex items-center justify-center px-[12px] text-[#ffffff] font-['BaseNeueCondensedBold'] text-[14px] tracking-[0.04em] uppercase leading-[100%] !w-fit !h-[33px]",
          descriptionCutoff: 30,
        },
      },
    },
    shopV2: {
      container: "flex flex-col !bg-[#17111d] overflow-hidden !pb-8",
      header:
        "text-[#ffffff] font-['BaseNeueCondensedBold'] text-[32px] tracking-[0.04em] text-left leading-[120%] px-4 sm:px-8 pt-4 sm:pt-8 !-mb-5 sm:!-mb-1",
      emptyState:
        "text-[#ffffff] font-['ArimoRegular'] text-[14px] text-left leading-[120%] px-4 sm:px-8 py-8",
      eventSection: {
        // first:pt-0 + the header's negative margin offset the hard-coded mb-9 under the Shop
        // header: Figma gap is 16px mobile / 32px desktop
        container: "px-4 sm:px-8 py-4 sm:py-8 first:pt-0 border-b border-[#ffffff]",
        header:
          "text-[#ffffff] font-['BaseNeueCondensedMedium'] text-[28px] tracking-[0.04em] text-left leading-[120%] mb-6",
        event: {
          container: "flex items-start gap-x-3 mb-6",
          // Figma Date Container: white box, #6d6d6d border, #17111d text
          dateBox:
            "bg-[#ffffff] border border-[#6d6d6d] rounded-[8px] p-1 w-[68px] h-[68px] flex flex-col items-center justify-center text-center shrink-0",
          month:
            "text-[#17111d] font-['BaseNeueCondensedMedium'] text-[16px] uppercase tracking-[0.04em] leading-[120%] text-center",
          day: "text-[#17111d] font-['BaseNeueCondensedMedium'] text-[16px] uppercase tracking-[0.04em] leading-[120%] text-center",
          details: "flex-1 min-w-0",
          name: "text-[#ffffff] font-['BaseNeueCondensedMedium'] text-[16px] tracking-[0.04em] text-left leading-[120%]",
          date: "text-[#ffffff] font-['ArimoRegular'] text-[12px] text-left leading-[120%] mt-2",
          location:
            "text-[#ffffff] font-['ArimoRegular'] text-[12px] text-left leading-[120%] mt-1",
        },
        tickets: {
          container: "flex flex-col overflow-hidden",
          ticket: {
            container:
              "flex flex-row justify-between items-start gap-x-4 leading-auto border-b border-[#ffffff] py-2",
            mediaContainer: "!hidden",
            media: "!hidden",
            name: "text-[#ffffff] font-['BaseNeueCondensedMedium'] text-[16px] tracking-[0.04em] text-left leading-[120%]",
            description:
              "text-[#ffffff] font-['ArimoRegular'] text-[14px] text-left leading-[120%] mt-1",
            price:
              "text-[#ffffff] font-['BaseNeueCondensedMedium'] text-[16px] tracking-[0.04em] text-left leading-[120%] mt-1",
            quantity:
              "text-[#ffffff] font-['BaseNeueCondensedBold'] text-[14px] tracking-[0.04em] uppercase text-left leading-[100%]",
            status:
              "text-[#ffffff] font-['BaseNeueCondensedMedium'] text-[16px] tracking-[0.04em] text-left leading-[120%]",
            counterContainer:
              "bg-[#c82550] !border-2 border-[#c82550] rounded-[8px] px-[12px] py-[12px] gap-x-[16px] !w-fit !h-9",
            plusMinusColor: "#ffffff",
            button:
              "bg-[#c82550] border-2 border-[#c82550] rounded-[8px] flex items-center px-[12px] text-[#ffffff] font-['BaseNeueCondensedBold'] text-[14px] tracking-[0.04em] uppercase text-left leading-[100%] !w-fit !h-[33px]",
            descriptionCutoff: 50,
          },
        },
      },
      membershipSection: {
        container: "px-4 sm:px-8 py-4 sm:py-8 border-b border-[#ffffff]",
        header:
          "text-[#ffffff] font-['BaseNeueCondensedMedium'] text-[28px] tracking-[0.04em] text-left leading-[120%] mb-6",
        products: {
          container: "flex flex-col overflow-hidden",
          product: {
            container:
              "flex flex-row justify-between items-start gap-x-4 leading-auto border-b border-[#ffffff] py-2",
            mediaContainer: "!hidden",
            media: "!hidden",
            name: "text-[#ffffff] font-['BaseNeueCondensedMedium'] text-[16px] tracking-[0.04em] text-left leading-[120%]",
            description:
              "text-[#ffffff] font-['ArimoRegular'] text-[14px] text-left leading-[120%] mt-1",
            price:
              "text-[#ffffff] font-['BaseNeueCondensedMedium'] text-[16px] tracking-[0.04em] text-left leading-[120%] mt-1",
            quantity:
              "text-[#ffffff] font-['BaseNeueCondensedBold'] text-[14px] tracking-[0.04em] uppercase text-left leading-[100%]",
            status:
              "text-[#ffffff] font-['BaseNeueCondensedMedium'] text-[16px] tracking-[0.04em] text-left leading-[120%]",
            counterContainer:
              "bg-[#c82550] !border-2 border-[#c82550] rounded-[8px] px-[12px] py-[12px] gap-x-[16px] !w-fit !h-9",
            plusMinusColor: "#ffffff",
            button:
              "bg-[#c82550] border-2 border-[#c82550] rounded-[8px] flex items-center px-[12px] text-[#ffffff] font-['BaseNeueCondensedBold'] text-[14px] tracking-[0.04em] uppercase text-left leading-[100%] !w-fit !h-[33px]",
            descriptionCutoff: 50,
          },
        },
      },
      merchSection: {
        container: "px-4 sm:px-8 py-4 sm:py-8",
        header:
          "text-[#ffffff] font-['BaseNeueCondensedMedium'] text-[28px] tracking-[0.04em] text-left leading-[120%] mb-6",
        products: {
          container: "grid grid-cols-2 sm:grid-cols-4 gap-4",
          product: {
            container: "cursor-pointer !bg-[#ffffff00] overflow-hidden",
            innerContainer: "flex flex-col",
            mediaContainer: "w-full overflow-hidden",
            media: "w-full !aspect-square object-cover",
            name: "text-[#ffffff] font-['BaseNeueCondensedMedium'] text-[16px] tracking-[0.04em] text-left leading-[120%] mt-3",
            description:
              "text-[#ffffff] font-['ArimoRegular'] text-[14px] text-left leading-[120%] mt-1",
            price:
              "text-[#ffffff] font-['BaseNeueCondensedMedium'] text-[16px] tracking-[0.04em] text-left leading-[120%] mt-1",
            quantity:
              "text-[#ffffff] font-['BaseNeueCondensedBold'] text-[14px] tracking-[0.04em] uppercase text-left leading-[100%]",
            status:
              "text-[#ffffff] font-['BaseNeueCondensedMedium'] text-[16px] tracking-[0.04em] text-left leading-[120%]",
            counterContainer:
              "bg-[#c82550] !border-2 border-[#c82550] rounded-[8px] px-[12px] py-[12px] gap-x-[16px] !w-fit !h-9",
            plusMinusColor: "#ffffff",
            button:
              "bg-[#c82550] border-2 border-[#c82550] rounded-[8px] flex items-center px-[12px] text-[#ffffff] font-['BaseNeueCondensedBold'] text-[14px] tracking-[0.04em] uppercase text-left leading-[100%] !w-fit !h-[33px]",
            descriptionCutoff: 50,
          },
        },
      },
    },
  },
}

export default XOXA
